import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import { Flex, Text, Box } from '@atlaskit/primitives';
import { IconButton } from '@atlaskit/button/new';
import CopyIcon from '@atlaskit/icon/glyph/copy';

import type { ContentVersionHistoryQuery_contentVersionHistory_nodes as VersionHistoryNode } from './graphql/__types__/ContentVersionHistoryQuery';
import { getFormattedDate } from './versionHistoryUtils';

const i18n = defineMessages({
	copyIconLabel: {
		id: 'version-history.copy.icon.label',
		defaultMessage: 'Copy icon',
		description: 'aria-label for copy icon',
	},
});

type VersionHistoryNodeType = {
	version: VersionHistoryNode;
};

export const VersionHistoryItem = ({ version }: VersionHistoryNodeType) => {
	const { formatMessage, formatDate, formatTime } = useIntl();

	return (
		<Box
			paddingBlock="space.100"
			paddingInlineEnd="space.150"
			paddingInlineStart="space.300"
			data-testId="version-history-item"
		>
			<Flex direction="row" alignItems="center" justifyContent="space-between">
				<Text size="medium">{getFormattedDate(version.updatedTime, formatDate, formatTime)}</Text>
				<IconButton appearance="subtle" icon={CopyIcon} label={formatMessage(i18n.copyIconLabel)} />
			</Flex>
		</Box>
	);
};
